<div id="PG_PaymentManagementModify" class="glb_formBGColor glb_paddingBottomMD glb_Font glb_Font" [ngClass]="ModalIdentifier">

    <!-- Close modal button. put this here on its own row, so that it stays put and won't bootstrap down to another row in smaller screen sizes -->
    <div class="glb_customFlexRow sticky-top">
        <div class="glb_headerBarBGDark glb_customFlexRow col-12 justify-content-end" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
            <div class="justify-content-start glb_boxedPaddingNarrow align-self-bottom glb_PaddingVerticalZeroOffset">
                <button id="BTN_ClosePaymentManagementModify" tabindex="3"
                    class="btn glb_clickableIconButtonStyleNone glb_clickableIconButtonColorDark glb_skinLightOutline" type="button"
                    (click)="globalFunctions.FeatureModal_Close(ModalIdentifier)">
                    <fa-icon [icon]="['fal', 'times']" class="fa-md glb_iconColorDark" matTooltip="Click to close"></fa-icon>
                </button>
            </div>
        </div>
    </div>

    <div class="glb_customFlexRow glb_boxedPadding">
        <div class="col-12 glb_Font header-padding glb_customFlexRow">
            <div class="glb_customFlexRow col-12">
                <div class="glb_customFlexRow col-12 col-md-8 col-lg-8 glb_paddingZeroOffset glb_paddingBottomSM">
                    <div class="col-12 glb_paddingZeroOffset">
                        <div class="glb_TitleLG glb_TitleLGMobile text-start glb_breakLongWords glb_paddingZeroOffset glb_paddingBottomSM text-white">
                            {{PageTitle}}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="ShowInterAccountTransferModify" class="glb_customFlexRow glb_boxedPaddingXS">
            <!-- Transfer From Account -->
            <div @fadeInSection [ngClass]="globalFunctions.L1SectionCSS">
                <div [ngClass]="globalFunctions.Col2CSS">
                    <FormInputDataUnit [ngClass]="globalFunctions.FlexCSS" [ParentComponent]="this" [ID]="'INP_TransferFrom'"
                        [DropdownOptions]="TransferFromAccountOptions">
                    </FormInputDataUnit>
                </div>
            </div>

            <!-- Transfer To Account -->
            <div @fadeInSection [ngClass]="globalFunctions.L1SectionCSS">
                <div [ngClass]="globalFunctions.Col2CSS">
                    <FormInputDataUnit [ngClass]="globalFunctions.FlexCSS" [ParentComponent]="this" [ID]="'INP_TransferTo'"
                        [DropdownOptions]="TransferToAccountOptions">
                    </FormInputDataUnit>
                </div>
            </div>

            <!-- Transfer Amount -->
            <div @fadeInSection [ngClass]="globalFunctions.L1SectionCSS">
                <div [ngClass]="globalFunctions.Col2CSS">
                    <FormInputDataUnit [ngClass]="globalFunctions.FlexCSS" [ParentComponent]="this" [ID]="'INP_TransferAmount'">
                    </FormInputDataUnit>
                </div>
            </div>

            <!-- Transfer Type -->
            <div @fadeInSection [ngClass]="globalFunctions.L1SectionCSS">
                <div [ngClass]="globalFunctions.Col2CSS">
                    <FormInputDataUnit [ngClass]="globalFunctions.FlexCSS" [ParentComponent]="this" [ID]="'INP_TransferType'"
                        [DropdownOptions]="TransferTypeOptions">
                    </FormInputDataUnit>
                </div>
            </div>

            <!-- Frequency -->
            <div *ngIf="ShowTransferFrequency" @fadeInSection [ngClass]="globalFunctions.L1SectionCSS">
                <div [ngClass]="globalFunctions.Col2CSS">
                    <FormInputDataUnit [ngClass]="globalFunctions.FlexCSS" [ParentComponent]="this" [ID]="'INP_Frequency'"
                        [DropdownOptions]="FrequencyOptions">
                    </FormInputDataUnit>
                </div>
            </div>

            <!-- Due Date -->
            <div @fadeInSection [ngClass]="globalFunctions.L1SectionCSS">

                <!-- Date Declared -->
                <div [ngClass]="globalFunctions.Col2CSS">

                    <!-- Primeng Calendar Date Picker -->
                    <FormInputDataUnit [ngClass]="globalFunctions.FlexCSS" [ParentComponent]="this" [ID]="'INP_DueDate'" [DTPMaxDate]="DTPMaxDate"
                        [DTPMinDate]="DTPMinDatePlusOneDay">
                    </FormInputDataUnit>
                </div>
            </div>

            <!-- Expiry Date -->
            <div *ngIf="ShowTransferExpiryDate" @fadeInSection [ngClass]="globalFunctions.L1SectionCSS">

                <!-- Date Declared -->
                <div [ngClass]="globalFunctions.Col2CSS">

                    <!-- Primeng Calendar Date Picker -->
                    <FormInputDataUnit [ngClass]="globalFunctions.FlexCSS" [ParentComponent]="this" [ID]="'INP_ExpiryDate'" [DTPMaxDate]="DTPMaxDate"
                        [DTPMinDate]="DTPMinDatePlusOneDay">
                    </FormInputDataUnit>
                </div>

                <!-- Date Declared -->
                <div [ngClass]="globalFunctions.Col2CSS">

                    <!-- Until Further Notice -->
                    <FormInputDataUnit [ngClass]="globalFunctions.FlexCSS" [ParentComponent]="this" [ID]="'INP_DueUntilFurtherNotice'">
                    </FormInputDataUnit>
                </div>
            </div>

            <!-- Submit section -->
            <div @fadeInSection class="glb_PaddingVerticalSM">
                <button id="BTN_SubmitTransfer" tabindex="13" [ngClass]="globalFunctions.FlexCSS"
                    class="glb_standardButton glb_skinLightOutline btn glb_BGColorSkin text-white" (click)="ProcessInterAccountTransfer_Submit()">
                    <span class="glb_flexGrow glb_Font glb_smallerText align-items-center justify-content-center">Save</span>
                </button>
            </div>
        </div>

        <!-- Bank Account Details Form -->
        <div *ngIf="ShowBankAccountModify" class="glb_customFlexRow glb_boxedPaddingXS">
            <!-- BSB Number -->
            <div @fadeInSection [ngClass]="globalFunctions.L1SectionCSS">
                <div [ngClass]="globalFunctions.Col2CSS">
                    <FormInputDataUnit [ngClass]="globalFunctions.FlexCSS" [ParentComponent]="this" [ID]="'INP_BSBNumber'"
                        [AutoCompleteControlTypeName]="'BSB No.'" [AutoCompleteCurrentValue]="CurrentBSBNumberValue" [AccountID]="TargetAccountID">
                    </FormInputDataUnit>
                </div>
            </div>

            <!-- Account Number -->
            <div @fadeInSection [ngClass]="globalFunctions.L1SectionCSS">
                <div [ngClass]="globalFunctions.Col2CSS">
                    <FormInputDataUnit [ngClass]="globalFunctions.FlexCSS" [ParentComponent]="this" [ID]="'INP_AccountNumber'">
                    </FormInputDataUnit>
                </div>
            </div>

            <!-- Account Name -->
            <div @fadeInSection [ngClass]="globalFunctions.L1SectionCSS">
                <div [ngClass]="globalFunctions.Col2CSS">
                    <FormInputDataUnit [ngClass]="globalFunctions.FlexCSS" [ParentComponent]="this" [ID]="'INP_AccountName'">
                    </FormInputDataUnit>
                </div>
            </div> <!-- Submit section -->
            <div @fadeInSection class="glb_PaddingVerticalSM">
                <button id="BTN_SaveBankAccount" tabindex="13" [ngClass]="globalFunctions.FlexCSS"
                    class="glb_standardButton glb_skinLightOutline btn glb_BGColorSkin text-white" (click)="BankAccount_Save()">
                    <span class="glb_flexGrow glb_Font glb_smallerText align-items-center justify-content-center">Save</span>
                </button>
            </div>
        </div>

        <!-- Customer Nominated Payment Form -->
        <div *ngIf="ShowCustomerNominatedPaymentModify" class="glb_customFlexRow glb_boxedPaddingXS">

            <!-- Payment Frequency -->
            <div @fadeInSection [ngClass]="globalFunctions.L1SectionCSS">
                <div [ngClass]="globalFunctions.Col2CSS">
                    <FormInputDataUnit [ngClass]="globalFunctions.FlexCSS" [ParentComponent]="this" [ID]="'INP_PaymentFrequency'"
                        [DropdownOptions]="CustomerNominatedFrequencyOptions" [AccountID]="TargetAccountID">
                    </FormInputDataUnit>
                </div>
            </div>

            <!-- Payment Amount -->
            <div @fadeInSection [ngClass]="globalFunctions.L1SectionCSS">
                <div [ngClass]="globalFunctions.Col2CSS">
                    <FormInputDataUnit [ngClass]="globalFunctions.FlexCSS" [ParentComponent]="this" [ID]="'INP_PaymentAmount'">
                    </FormInputDataUnit>
                </div>
            </div>

            <!-- Next Payment Date -->
            <div @fadeInSection [ngClass]="globalFunctions.L1SectionCSS">
                <div [ngClass]="globalFunctions.Col2CSS">
                    <FormInputDataUnit [ngClass]="globalFunctions.FlexCSS" [ParentComponent]="this" [ID]="'INP_NextPaymentDate'"
                        [DTPMaxDate]="DTPMaxDate" [DTPMinDate]="DTPMinDate">
                    </FormInputDataUnit>
                </div>
            </div>

            <!-- Expiry Date - only shows for non-Once frequency -->
            <div *ngIf="ShowPaymentExpiryDate" @fadeInSection [ngClass]="globalFunctions.L1SectionCSS">
                <!-- Date Input -->
                <div [ngClass]="globalFunctions.Col2CSS">
                    <FormInputDataUnit [ngClass]="globalFunctions.FlexCSS" [ParentComponent]="this" [ID]="'INP_PaymentExpiryDate'"
                        [DTPMaxDate]="DTPMaxDate" [DTPMinDate]="DTPMinDate">
                    </FormInputDataUnit>
                </div>

                <!-- Until Further Notice checkbox -->
                <div [ngClass]="globalFunctions.Col2CSS">
                    <FormInputDataUnit [ngClass]="globalFunctions.FlexCSS" [ParentComponent]="this" [ID]="'INP_UntilFurtherNotice'">
                    </FormInputDataUnit>
                </div>
            </div>

            <!-- Payment Transaction -->
            <div @fadeInSection [ngClass]="globalFunctions.L1SectionCSS">
                <div [ngClass]="globalFunctions.Col2CSS">
                    <FormInputDataUnit [ngClass]="globalFunctions.FlexCSS" [ParentComponent]="this" [ID]="'INP_PaymentTxn'"
                        [DropdownOptions]="PaymentTransactionOptions">
                    </FormInputDataUnit>
                </div>
            </div>

            <!-- Charge Transaction -->
            <div @fadeInSection [ngClass]="globalFunctions.L1SectionCSS">
                <div [ngClass]="globalFunctions.Col2CSS">
                    <FormInputDataUnit [ngClass]="globalFunctions.FlexCSS" [ParentComponent]="this" [ID]="'INP_ChargeTxn'"
                        [DropdownOptions]="ChargeTransactionOptions">
                    </FormInputDataUnit>
                </div>
            </div>

            <!-- Note -->
            <div @fadeInSection [ngClass]="globalFunctions.L1SectionCSS">
                <div [ngClass]="globalFunctions.Col2CSS">
                    <FormInputDataUnit [ngClass]="globalFunctions.FlexCSS" [ParentComponent]="this" [ID]="'INP_Note'">
                    </FormInputDataUnit>
                </div>
            </div>

            <!-- Submit section -->
            <div @fadeInSection class="glb_PaddingVerticalSM">
                <button id="BTN_SavePayment" tabindex="13" [ngClass]="globalFunctions.FlexCSS"
                    class="glb_standardButton glb_skinLightOutline btn glb_BGColorSkin text-white" (click)="CustomerNominatedPayment_Save()">
                    <span class="glb_flexGrow glb_Font glb_smallerText align-items-center justify-content-center">Save</span>
                </button>
            </div>
        </div>
        <!-- Scheduled Payment Form -->
        <div *ngIf="ShowScheduledPaymentModify" class="glb_customFlexRow glb_boxedPaddingXS">
            <!-- Monthly Instalment Information Header -->
            <div @fadeInSection [ngClass]="globalFunctions.L1SectionCSS">
                <div class="col-12">
                    <div class="glb_TitleSM text-white">Current Scheduled Payment Information</div>
                </div>
            </div>
            <!-- Display Payment Information -->
            <div @fadeInSection [ngClass]="globalFunctions.L1SectionCSS">
                <div class="col-12">
                    <div class="glb_customFlexRow glb_boxedPadding glb_allBordersGreyRounded">
                        <ng-container *ngIf="!ExistingScheduledPayment">
                            <div class="col-12 glb_customFlexRow">
                                <div class="col-6 glb_LabelFontDark">Monthly Instalment Amount:</div>
                                <div class="col-6 text-white">{{MonthlyInstalmentAmountFormatted}}</div>
                            </div>
                        </ng-container>
                        <!-- Display existing scheduled payment details if available -->
                        <ng-container *ngIf="ExistingScheduledPayment">
                            <div class="col-12 glb_customFlexRow">
                                <div class="col-6 glb_LabelFontDark">Monthly Instalment Amount:</div>
                                <div class="col-6 text-white">{{ExistingScheduledPayment.InstalmentAmount_lbl}}</div>
                            </div>
                            <div class="col-12 glb_customFlexRow">
                                <div class="col-6 glb_LabelFontDark">Current Direct Debit Amount:</div>
                                <div class="col-6 text-white">{{ExistingScheduledPayment.DirectDebitAmount_lbl}}</div>
                            </div>
                            <div class="col-12 glb_customFlexRow">
                                <div class="col-6 glb_LabelFontDark">Payment Frequency:</div>
                                <div class="col-6 text-white">{{ExistingScheduledPayment.Frequency}}</div>
                            </div>
                            <div class="col-12 glb_customFlexRow">
                                <div class="col-6 glb_LabelFontDark">Next Payment Date:</div>
                                <div class="col-6 text-white">{{ExistingScheduledPayment.NextPaymentDate}}</div>
                            </div>
                            <div class="col-12 glb_customFlexRow">
                                <div class="col-6 glb_LabelFontDark">Payment Type:</div>
                                <div class="col-6 text-white">{{ExistingScheduledPayment.PaymentMethod}}</div>
                            </div>
                            <div class="col-12 glb_customFlexRow">
                                <div class="col-6 glb_LabelFontDark">Notes:</div>
                                <div class="col-6 text-white">{{ExistingScheduledPayment.Notes}}</div>
                            </div>

                            <div class="col-12 glb_customFlexRow">
                                <div class="col-12">
                                    <div class="glb_Font glb_smallText text-warning mb-2">
                                        Note: Saving changes will replace the existing scheduled payment.
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>

            <!-- Payment Type -->
            <div @fadeInSection [ngClass]="globalFunctions.L1SectionCSS">
                <div [ngClass]="globalFunctions.Col2CSS">
                    <FormInputDataUnit [ngClass]="globalFunctions.FlexCSS" [ParentComponent]="this" [ID]="'INP_PaymentMethod'"
                        [DropdownOptions]="PaymentMethodOptions">
                    </FormInputDataUnit>
                </div>
            </div>

            <!-- Payment Type Description -->
            <div @fadeInSection *ngIf="PaymentTypeDescriptionMessage" [ngClass]="globalFunctions.L1SectionCSS">
                <div class="col-12">
                    <div class="glb_Font glb_smallText text-info">
                        ** {{PaymentTypeDescriptionMessage}}
                    </div>
                </div>
            </div>

            <!-- Payment Frequency -->
            <div @fadeInSection [ngClass]="globalFunctions.L1SectionCSS">
                <div [ngClass]="globalFunctions.Col2CSS">
                    <FormInputDataUnit [ngClass]="globalFunctions.FlexCSS" [ParentComponent]="this" [ID]="'INP_ScheduledFrequency'"
                        [DropdownOptions]="ScheduleFrequencyOptions" [AccountID]="TargetAccountID">
                    </FormInputDataUnit>
                </div>
            </div>

            <!-- Next Payment Date -->
            <div @fadeInSection [ngClass]="globalFunctions.L1SectionCSS">
                <div [ngClass]="globalFunctions.Col2CSS">
                    <FormInputDataUnit [ngClass]="globalFunctions.FlexCSS" [ParentComponent]="this" [ID]="'INP_ScheduledNextPaymentDate'"
                        [DTPMaxDate]="DTPMaxDate" [DTPMinDate]="DTPMinDate">
                    </FormInputDataUnit>
                </div>
            </div>

            <!-- Scheduled Direct Debit Amount -->
            <div @fadeInSection *ngIf="ShowMinimumPaymentAmount" [ngClass]="globalFunctions.L1SectionCSS">
                <div [ngClass]="globalFunctions.Col2CSS">
                    <FormInputDataUnit [ngClass]="globalFunctions.FlexCSS" [ParentComponent]="this" [ID]="'INP_DirectDebitAmount'">
                    </FormInputDataUnit>
                </div>
            </div>

            <!-- Customer Nominated Amount -->
            <div @fadeInSection *ngIf="ShowCustomerNominatedInput" [ngClass]="globalFunctions.L1SectionCSS">
                <div [ngClass]="globalFunctions.Col2CSS">
                    <FormInputDataUnit [ngClass]="globalFunctions.FlexCSS" [ParentComponent]="this" [ID]="'INP_CustomerNominatedAmount'">
                    </FormInputDataUnit>
                </div>
            </div>

            <!-- Additional Payment Amount -->
            <div @fadeInSection *ngIf="ShowAdditionalPaymentInput" [ngClass]="globalFunctions.L1SectionCSS">
                <div [ngClass]="globalFunctions.Col2CSS">
                    <FormInputDataUnit [ngClass]="globalFunctions.FlexCSS" [ParentComponent]="this" [ID]="'INP_AdditionalAmount'">
                    </FormInputDataUnit>
                </div>
            </div>

            <!-- Total Payment Amount -->
            <div @fadeInSection *ngIf="ShowTotalDDAmount" [ngClass]="globalFunctions.L1SectionCSS">
                <div [ngClass]="globalFunctions.Col2CSS">
                    <FormInputDataUnit [ngClass]="globalFunctions.FlexCSS" [ParentComponent]="this" [ID]="'INP_TotalAmount'">
                    </FormInputDataUnit>
                </div>
            </div>

            <!-- Note -->
            <div @fadeInSection [ngClass]="globalFunctions.L1SectionCSS">
                <div [ngClass]="globalFunctions.Col2CSS">
                    <FormInputDataUnit [ngClass]="globalFunctions.FlexCSS" [ParentComponent]="this" [ID]="'INP_Note'">
                    </FormInputDataUnit>
                </div>
            </div>

            <!-- Submit section -->
            <div @fadeInSection class="glb_PaddingVerticalSM">
                <button id="BTN_SaveScheduledPayment" tabindex="13" [ngClass]="globalFunctions.FlexCSS"
                    class="glb_standardButton glb_skinLightOutline btn glb_BGColorSkin text-white" (click)="ScheduledPayment_Save()">
                    <span class="glb_flexGrow glb_Font glb_smallerText align-items-center justify-content-center">Save</span>
                </button>
            </div>
        </div>

        <!-- Defer Payment Form -->
        <div *ngIf="ShowDeferPaymentModify" class="glb_customFlexRow glb_boxedPaddingXS">
            <!-- Payment Information Header -->
            <div @fadeInSection [ngClass]="globalFunctions.L1SectionCSS">
                <div class="col-12">
                    <div class="glb_TitleSM text-white">Payment Information</div>
                </div>
            </div>

            <!-- Display current payment details -->
            <div *ngIf="SelectedPaymentDetails" @fadeInSection [ngClass]="globalFunctions.L1SectionCSS">
                <div class="col-12">
                    <div class="glb_customFlexRow glb_boxedPadding glb_allBordersGreyRounded">
                        <div class="col-6 glb_LabelFontDark">Amount:</div>
                        <div class="col-6 text-white">{{SelectedPaymentDetails.DirectDebitAmount_lbl || SelectedPaymentDetails.DirectDebitAmount}}
                        </div>

                        <div class="col-6 glb_LabelFontDark">Frequency:</div>
                        <div class="col-6 text-white">{{SelectedPaymentDetails.Frequency}}</div>

                        <div class="col-6 glb_LabelFontDark">Next Payment Date:</div>
                        <div class="col-6 text-white">{{SelectedPaymentDetails.NextPaymentDate}}</div>
                    </div>
                </div>
            </div>

            <!-- Defer Months Selection -->
            <div @fadeInSection [ngClass]="globalFunctions.L1SectionCSS">
                <div [ngClass]="globalFunctions.Col2CSS">
                    <FormInputDataUnit [ngClass]="globalFunctions.FlexCSS" [ParentComponent]="this" [ID]="'INP_DeferMonths'"
                        [DropdownOptions]="DeferMonthsOptions">
                    </FormInputDataUnit>
                </div>
            </div>

            <!-- Submit section -->
            <div @fadeInSection class="glb_PaddingVerticalSM">
                <button id="BTN_SaveDeferPayment" tabindex="13" [ngClass]="globalFunctions.FlexCSS"
                    class="glb_standardButton glb_skinLightOutline btn glb_BGColorSkin text-white" (click)="DeferPayment_Save()">
                    <span class="glb_flexGrow glb_Font glb_smallerText align-items-center justify-content-center">Defer Payment</span>
                </button>
            </div>
        </div>

        <!-- Change Frequency Form -->
        <div *ngIf="ShowChangeFrequencyModify" class="glb_customFlexRow glb_boxedPaddingXS">
            <!-- Payment Information Header -->
            <div @fadeInSection [ngClass]="globalFunctions.L1SectionCSS">
                <div class="col-12">
                    <div class="glb_TitleSM text-white">Payment Information</div>
                </div>
            </div>

            <!-- Display current payment details -->
            <div *ngIf="SelectedPaymentDetails" @fadeInSection [ngClass]="globalFunctions.L1SectionCSS">
                <div class="col-12">
                    <div class="glb_customFlexRow glb_boxedPadding glb_allBordersGreyRounded">
                        <div class="col-6 glb_LabelFontDark">Amount:</div>
                        <div class="col-6 text-white">{{SelectedPaymentDetails.DirectDebitAmount_lbl || SelectedPaymentDetails.DirectDebitAmount}}
                        </div>

                        <div class="col-6 glb_LabelFontDark">Current Frequency:</div>
                        <div class="col-6 text-white">{{SelectedPaymentDetails.Frequency}}</div>

                        <div class="col-6 glb_LabelFontDark">Next Payment Date:</div>
                        <div class="col-6 text-white">{{SelectedPaymentDetails.NextPaymentDate}}</div>
                    </div>
                </div>
            </div> <!-- New Frequency Selection -->
            <div @fadeInSection [ngClass]="globalFunctions.L1SectionCSS">
                <div [ngClass]="globalFunctions.Col2CSS">
                    <FormInputDataUnit [ngClass]="globalFunctions.FlexCSS" [ParentComponent]="this" [ID]="'INP_NewFrequency'"
                        [DropdownOptions]="AvailableFrequencyOptions" [AccountID]="TargetAccountID">
                    </FormInputDataUnit>
                </div>
            </div>

            <!-- Submit section -->
            <div @fadeInSection class="glb_PaddingVerticalSM">
                <button id="BTN_SaveChangeFrequency" tabindex="13" [ngClass]="globalFunctions.FlexCSS"
                    class="glb_standardButton glb_skinLightOutline btn glb_BGColorSkin text-white" (click)="ChangeFrequency_Save()">
                    <span class="glb_flexGrow glb_Font glb_smallerText align-items-center justify-content-center">Save Changes</span>
                </button>
            </div>
        </div>
    </div>
</div>